import digitalData from 'digital-data';

export const promotion = () => {

  window.LIFE_CYCLE_EVENT_BUS.on('@@PROMOTION/CLICK', (payload) => {
    if (window.isDebugMode) {
      console.log('%c @@PROMOTION/CLICK is deprecated.', 'background: red; color: black', payload);
    }
  });

  window.LIFE_CYCLE_EVENT_BUS.on('promotion.click', ({ output }) => {
    const ddoEvent = {
      eventInfo: {
        eventName: 'promotion details'
      },
      category: {
        primaryCategory: 'tooltip'
      }
    };
    (digitalData.event || []).push(ddoEvent);
  });
};
